module.exports = __webpack_public_path__ + "img/img-anim.76890af1.png";